(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["SlotCarLapCounter-v2.0.84-(284)"] = factory();
	else
		root["SlotCarLapCounter-v2.0.84-(284)"] = factory();
})(globalThis, () => {
return 